<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.col.colName']">
              <a-input  v-model="queryParam.colName" allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.col.publishStatusName']">
              <j-dict-select-tag  v-model="queryParam.publishStatus" dictCode="hhemp_publish_status" allow-clear/>
            </a-form-item>
          </a-col>


          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24" v-if="this.$store.getters.applicationCode == 'emp_platform'">
              <a-form-item :label="language['emp.col.entrance.entranceName']">
                <a-select v-model="queryParam.entranceId" allowClear  :disabled="isDisable">
                  <a-select-option v-for="(item,index) in entranceList" :key="index" :value="item.id" allowClear>
                    {{ item.entranceName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['emp.col.templateTypeName']">
                <j-dict-select-tag :placeholder="language['common.pleaseChoose']+language['emp.col.templateTypeName']" type="list" v-model="queryParam.templateType" dictCode="emp_col_template_type"  allow-clear/>
              </a-form-item>
            </a-col>
          </template>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>

              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton']  : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <div class="table-operator" v-if="!onlyView">
      <a-button @click="handleAdd" v-has="'cmscol:insert'" type="primary" icon="plus">{{this.language['common.insertButton']}}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @expand="expand"
        @expandedRowsChange="expandedRowsChange"
        :expandedRowKeys="expandedRowKeys"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleManagers(record)"
             v-if="(record.topTemplateType == '1'&&record.colLevel=='2')//服务公告模版
                 ||(record.topTemplateType == '2'&&record.colLevel=='1')//教育训练专区模版
                 ||(record.topTemplateType == '3'&&record.colLevel=='2')//常见问题模版
                 ||(record.topTemplateType == '4'&&record.colLevel=='2')//资源与下载模版
                 ||(record.topTemplateType == '5'&&record.colLevel=='1')//精选服务模版
                 ||(record.topTemplateType == '6'&&record.colLevel=='2')//关于我们模版
                 ||(record.topTemplateType == '7'&&record.colLevel=='1')//为你推荐模版
                 ||(record.topTemplateType == '8'&&record.colLevel=='3')//文件管理模版
                 //模板九
                  ||(record.topTemplateType == '9'&&record.colLevel=='2')"
             v-has="'cmscol:managers'">{{language['emp.empCmsEntrance.managers']}}</a>
          <a-divider v-has="'cmscol:managers'" type="vertical"
                     v-if="(record.topTemplateType == '1'&&record.colLevel=='2')//服务公告模版
                           ||(record.topTemplateType == '2'&&record.colLevel=='1')//教育训练专区模版
                           ||(record.topTemplateType == '3'&&record.colLevel=='2')//常见问题模版
                           ||(record.topTemplateType == '4'&&record.colLevel=='2')//资源与下载模版
                           ||(record.topTemplateType == '5'&&record.colLevel=='1')//精选服务模版
                           ||(record.topTemplateType == '6'&&record.colLevel=='2')//关于我们模版
                           ||(record.topTemplateType == '7'&&record.colLevel=='1')//为你推荐模版
                           ||(record.topTemplateType == '8'&&record.colLevel=='3')//文件管理模版
                           //模板九
                           ||(record.topTemplateType == '9'&&record.colLevel=='2')"/>
          <!--<a @click="handleContentList(record)" v-has="'cmscol:contentList'"
                      v-if="(record.topTemplateType == '1'&&record.colLevel=='2')//服务公告模版
                           ||(record.topTemplateType == '2'&&record.colLevel=='1')//教育训练专区模版
                           ||(record.topTemplateType == '3'&&record.colLevel=='2')//常见问题模版
                           ||(record.topTemplateType == '4'&&record.colLevel=='2')//资源与下载模版
                           ||(record.topTemplateType == '5'&&record.colLevel=='1')//精选服务模版
                           ||(record.topTemplateType == '6'&&record.colLevel=='2')//关于我们模版
                           ||(record.topTemplateType == '7'&&record.colLevel=='1')//为你推荐模版
                           //文件管理模版
                           ||(record.topTemplateType == '8'&&record.colLevel=='3')"
          >{{language['emp.col.contentTab']}}</a>-->
          <a @click="addChildren(record)" v-has="'cmscol:addClass'"
             v-if="(record.topTemplateType == '1'&&record.colLevel=='1')//服务公告模版
                    ||(record.topTemplateType == '3'&&record.colLevel=='1')//常见问题模版
                    ||(record.topTemplateType == '4'&&record.colLevel=='1')//资源与下载模版
                    ||(record.topTemplateType == '6'&&record.colLevel=='1')//关于我们模版
                    ||(record.topTemplateType == '8'&&(record.colLevel=='1'||record.colLevel=='2'))//文件管理模版
                     //模板9
                    ||(record.topTemplateType == '9'&&(record.colLevel=='1'))"
          >{{language['emp.col.addClassification']}}</a>
          <a-divider type="vertical"  v-has="'cmscol:addClass'"
                     v-if="(record.topTemplateType == '1'&&record.colLevel=='1')//服务公告模版
                    ||(record.topTemplateType == '3'&&record.colLevel=='1')//常见问题模版
                    ||(record.topTemplateType == '4'&&record.colLevel=='1')//资源与下载模版
                    ||(record.topTemplateType == '6'&&record.colLevel=='1')//关于我们模版
                     ||(record.topTemplateType == '8'&&(record.colLevel=='1'||record.colLevel=='2'))//文件管理模版
                     //模板9
                    ||(record.topTemplateType == '9'&&(record.colLevel=='1'))"
          />
          <!--          <a @click="handleApplication(record)">应用</a>-->
          <!--          <a-divider type="vertical" />-->
          <a @click="handleEdit(record)" v-has="'cmscol:edit'">{{language['common.edit']}}</a>
          <a-divider type="vertical" v-has="'cmscol:edit'" />
          <a @click="publish(record)" v-has="'cmscol:updown'" v-if="record.publishStatus=='unpublished'">{{language['emp.col.status.publish']}}</a>
          <a @click="unpublish(record)" v-has="'cmscol:updown'" v-if="record.publishStatus=='published'">{{language['emp.col.status.unpublish']}}</a>
          <a-divider type="vertical" v-has="'cmscol:updown'"/>
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'cmscol:detail'">
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item v-has="'cmscol:delete'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                    <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

        <span slot="colLevel" slot-scope="text,record">
          <span v-if="record.colLevel == '1'">{{language['emp.col.colLevel_one']}}</span>
          <span v-else>{{language['emp.col.colLevel_two']}}</span>
        </span>

      </a-table>
    </div>

    <cms-col-tbl-modal ref="modalForm" @ok="searchQuery"></cms-col-tbl-modal>
    <cms-col-tbl-children-modal ref="childrenModalFrom" @ok="searchQuery"/>
    <cms-content-tbl-list-modal ref="listModal" @ok="searchQuery"></cms-content-tbl-list-modal>
    <cms-col-application-model ref="applicationModel" @ok="searchQuery"></cms-col-application-model>
    <cms-col-tbl-manager-modal ref="colManager"/>
  </a-card>
</template>

<script>

import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import CmsColTblModal from './modules/CmsColTblModal'
import CmsColTblChildrenModal from './modules/CmsColTblChildrenModal'
import { getAction } from '@/api/manage'
import CmsContentTblListModal from './modules/CmsContentTblListModal'
import CmsColApplicationModel from './modules/CmsColApplicationModel'
import CmsColTblManagerModal from './modules/CmsColTblManagerModal'

export default {
  name: 'CmsColTblListInclude',
  mixins:[JeecgListMixin, mixinDevice],
  components: {
    CmsColTblModal,
    CmsColTblChildrenModal,
    CmsContentTblListModal,
    CmsColApplicationModel,
    CmsColTblManagerModal
  },
  data () {
    return {

      innerColumns:[
        {
          title:'栏目名称',
          align:"left",
          dataIndex: 'colName'
        },
        {
          title:'编号',
          align:"center",
          dataIndex: 'colCode'
        },
        {
          title:'地区',
          align:"center",
          dataIndex: 'entrance.entranceName'
        },
        {
          title:'发布人',
          align:"center",
          dataIndex: 'publisher',
          customRender:function (text,record){
            if(record.publishStatus == 'published'){
              return  text
            }else{
              return ""
            }
          }
        },
        {
          title:'发布时间',
          align:"center",
          dataIndex: 'publishTime',
          customRender:function (text,record) {
            if(record.publishStatus == 'published'){
              return !text?"":(text.length>19?text.substr(0,19):text)
            }else{
              return "";
            }
          }
        },
        {
          title:'发布状态',
          align:"center",
          dataIndex: 'publishStatusName'
        },
        {
          title:'內容数（分类数）',
          align:"center",
          dataIndex: 'contentNumber',
          customRender:function (text,r) {
            if(r.childNumber>0){
              return r.childNumber
            }else{
              return text
            }
          }
        },
        {
          title:'排序',
          align:"center",
          dataIndex: 'sortNo'
        },
        {
          title:'备注',
          align:"center",
          dataIndex: 'remark'
        },
        {
          title: '操作',
          dataIndex: 'innerAction',
          align:"center",
          width:147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      innerData:[],

      description: 'cms_col_tbl管理页面',
      expandedRowKeys:[],
      // 表头
      columns: [
        /*{
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },*/
        {
          title:this.$store.getters.language['emp.col.colName'],
          align:"center",
          dataIndex: 'colName',
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title:this.$store.getters.language['emp.col.colCode'],
          align:"center",
          dataIndex: 'colCode'
        },
        {
          title:this.$store.getters.language['emp.col.entrance.entranceName'],
          align:"center",
          dataIndex: 'entrance.entranceName'
        },
        {
          title:this.$store.getters.language['emp.col.colLevel'],
          align:"center",
          dataIndex: 'colLevel',
          scopedSlots:{ customRender: 'colLevel' },
          /*customRender:function (text,record){
            if(record.colLevel == '1'){
              return this.$store.getters.language['emp.col.colLevel_one']
            }else{
              return this.$store.getters.language["emp.col.colLevel_two"]
            }
          }*/
        },
        {
          title:this.$store.getters.language['emp.col.templateTypeName'],
          align:"center",
          dataIndex: 'templateTypeName',
          customRender:function (text,record){
            if(record.colLevel == '1'){
              return  text
            }else{
              return "-"
            }
          }
        },
        {
          title:this.$store.getters.language['emp.col.publisher'],
          align:"center",
          dataIndex: 'publisher',
          customRender:function (text,record){
            if(record.publishStatus == 'published'){
              return  text
            }else{
              return ""
            }
          }
        },
        {
          title:this.$store.getters.language['emp.col.publishTime'],
          align:"center",
          dataIndex: 'publishTime',
          customRender:function (text,record) {
            if(record.publishStatus == 'published'){
              return !text?"":(text.length>19?text.substr(0,19):text)
            }else{
              return "";
            }
          }
        },
        /*{
          title:'发布应用',
          align:"center",
          dataIndex: 'publishApplications'
        },*/
        {
          title:this.$store.getters.language['emp.col.publishStatusName'],
          align:"center",
          dataIndex: 'publishStatusName'
        },
        {
          title:this.$store.getters.language['emp.col.contentNumber'],
          align:"center",
          dataIndex: 'contentNumber',
          customRender:function (text,r) {
            if(r.childNumber>0){
              return r.childNumber
            }else{
              return text
            }
          }
        },
        {
          title:this.$store.getters.language['emp.col.sortNo'],
          align:"center",
          dataIndex: 'sortNo'
        },
       /* {
          title:'刪除标示',
          align:"center",
          dataIndex: 'delFlag'
        },*/
        {
          title:this.$store.getters.language['emp.col.remark'],
          align:"center",
          dataIndex: 'remark'
        },
        {
          title: this.$store.getters.language['common.action'],
          dataIndex: 'action',
          align:"center",
          // fixed:"right",
          width:147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: "/hhemp/col/cmscoltbls",
        delete: "/hhemp/col/cmscoltbl",
        deleteBatch: "/hhemp/col/cmscoltbl/batch",
        exportXlsUrl: "/hhemp/col/export-xls",
        importExcelUrl: "hhemp/col/import-excel",
        publish: "/hhemp/col/publishstatus",

      },
      dictOptions:{},
      superFieldList:[],
      entranceList:[]
    }
  },
  created() {
    this.getSuperFieldList();
    this.initEntranceList();
  },
  computed: {
    importExcelUrl: function(){
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
    language() {
      return this.$store.getters.language
    },
    /*tableProps() {
      let _this = this
      return {
        // 列表项是否可选择
        rowSelection: {
          selectedRowKeys: _this.selectedRowKeys,
          onChange: (selectedRowKeys) => _this.selectedRowKeys = selectedRowKeys
        }
      }
    }*/
  },
  methods: {
    handleDetail(record){
      record.flag = 'detail'

      if(record.colLevel == '1'){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title=this.language['common.detailsButton'];
        this.$refs.modalForm.disableSubmit = true;
      }else if(record.colLevel == '2'){
        this.$refs.childrenModalFrom.edit(record);
        this.$refs.childrenModalFrom.title=this.language['common.detailsButton'];
        this.$refs.childrenModalFrom.disableSubmit = true;
      }
    },
    initEntranceList(){

      getAction("/hhemp/entrance/empcmsentrancesPage", {pageNo:1,pageSize:9999}).then((res) => {
        if (res.success) {
         this.entranceList=  res.result.records;
          console.log(" this.entranceList：", this.entranceList)
        }
      })
    },
      searchQuery(){
      //this.expandedRowKeys = []
        this.loadData(1);
    },
     loadData(arg) {
      if(!this.url.list){
        // this.$message.error("请设置url.list属性!")
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();//查询条件
      this.loading = true;
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          const result = res.result.records || res.result
          this.dataSource = result.map((v, i)=>{
            v.key = i + 1;
            return v;
          });
          this.cacheData = JSON.parse(JSON.stringify(result));

          if(res.result.total)
          {
            this.ipagination.total = res.result.total;
          }else{
            this.ipagination.total = 0;
          }

          if (this.loadDataSuccess && typeof (this.loadDataSuccess) === 'function') {
            // the animation is done so lets loadDataSuccess
            this.loadDataSuccess()
          }

          //初始化子节点展开的数据
          this.expandedRowKeys.forEach(element => {
          let record = this.dataSource.find(item => item.id === element);
          let expanded={};
            this.expand(expanded,record);
          });


          //update-end---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
        }else{
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    searchReset() {
      //重置
      this.expandedRowKeys = []
      this.queryParam = {}
      this.loadData(1);
    },
    expandedRowsChange(expandedRows){
      this.expandedRowKeys = expandedRows
      console.log("expandedRows:",expandedRows)
    },
    expand(expanded,record){
      console.log("record:",record)
      if(expanded){
        // this.expandedRowKeys.push(record);
        getAction("/hhemp/col/getChildrenCmscoltbls",{parentColId:record.id}).then(res=>{
          if(res.success){
            // this.expandedRowKeys = [record.id]
            record.children = res.result;
            // this.innerData = [res.result];
          }
        })
      }else{
        // this.expandedRowKeys = []
        // this.innerData = [];
      }
    },
    addChildren(record){
      this.$refs.childrenModalFrom.title = this.language["common.insertButton"]
      this.$refs.childrenModalFrom.add(record);
    },
    handleAdd(){
      this.$refs.modalForm.title = this.language["common.insertButton"]
      this.$refs.modalForm.add();
    },
    handleEdit(record){
      if(record.colLevel == '1'){
        this.$refs.modalForm.title = this.language["common.edit"]
        this.$refs.modalForm.edit(record);
      }else {
        this.$refs.childrenModalFrom.title = this.language["common.edit"]
        this.$refs.childrenModalFrom.edit(record);
      }
    },
    initDictConfig(){
    },
    getSuperFieldList(){
      let fieldList=[];
      fieldList.push({type:'string',value:'colCode',text:'栏位编号',dictCode:''})
      fieldList.push({type:'string',value:'colName',text:'栏位名称',dictCode:''})
      fieldList.push({type:'string',value:'templateType',text:'模板类型',dictCode:''})
      fieldList.push({type:'string',value:'publishStatus',text:'发布状态',dictCode:'hhemp_publish_status'})
      fieldList.push({type:'string',value:'publisher',text:'发布人',dictCode:''})
      fieldList.push({type:'date',value:'publishTime',text:'发布时间'})
      fieldList.push({type:'string',value:'publishApplications',text:'发布应用',dictCode:'hhemp_applications'})
      /*fieldList.push({type:'int',value:'detailNumber',text:'明细数量',dictCode:''})*/
      /*fieldList.push({type:'int',value:'sortNo',text:'排序',dictCode:''})*/
      /*fieldList.push({type:'string',value:'delFlag',text:'刪除标示',dictCode:''})*/
      fieldList.push({type:'string',value:'remark',text:'备注',dictCode:''})
      this.superFieldList = fieldList
    },
    handleContentList(record){
      //this.$router.push({path:'/hhemp/cmsContentTblList', query:{colid:record.id}});

      this.$parent.tabChange(record.id);
      if(record.topTemplateType == '7' && record.colLevel=='1'){
        this.$parent.appList(record.id)
      }
    },
    handleApplication(record){
      this.$refs.applicationModel.edit(record);
    },
    publish: function(record){
      var that = this;
      //上架
      this.$confirm({
        title:that.language["emp.col.status.publish"],
        content:that.language["emp.col.status.sureUpShelf"],
        onOk: function(){
          getAction(that.url.publish,{id:record.id,status:'published'}).then((res)=>{
            if(res.success){
              that.$message.success(that.language["operationSuccess"]);
              that.searchQuery();
              // that.onClearSelected();
            }else{
              that.$message.warn(that.language['common.errorContext'])
            }
          });
        }
      });
    },
    unpublish: function(record){
      var that = this;
      //上架
      this.$confirm({
        title:that.language["emp.col.status.unpublish"],
        content:that.language["emp.col.status.sureDownShelf"],
        onOk: function(){
          getAction(that.url.publish,{id:record.id,status:'unpublished'}).then((res)=>{
            if(res.success){
              that.$message.success(that.language["operationSuccess"]);
              that.searchQuery();
              // that.onClearSelected();
            }else{
              that.$message.warn(that.language['common.errorContext'])
            }
          });
        }
      });
    },
    handleManagers(record){
      this.$refs.colManager.edit(record);
    },

  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
